import React, {useState} from 'react';
import {FaArrowCircleUp} from 'react-icons/fa';
// import { Button } from "reactstrap";
import "./index.css";
const ScrollButton = () =>{
  
  const [visible, setVisible] = useState(false)
  
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300){
      setVisible(true)
    } 
    else if (scrolled <= 300){
      setVisible(false)
    }
  };
  
  const scrollToTop = () =>{
    window.scrollTo({
      top: 0, 
      behavior: 'smooth'
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };
  
  window.addEventListener('scroll', toggleVisible);
  
  return (
  
     
     <div style={{backgroundColor:'none',color:'#D3C086',border:'none',width:'0%',outline:'none',paddingLeft:'90%',bottom:'13%',cursor:'pointer',position:'fixed',fontSize:'3rem'}}>
              
         
     
        <FaArrowCircleUp  onClick={scrollToTop} 
     style={{display: visible ? 'inline' : 'none'}} 
     />

     </div>  


  );
}
  
export default ScrollButton;